import React from 'react';
import { Card, CardBody } from 'reactstrap';
import ClinicalNotes from './clinicalNotes';
import SmsActivity from './smsActivity';
import VoiceCalls from './voiceCalls';
import CCMManualInteractionTimes from './manualInteractionTimes';

const ClinicalActivity = () => (
  <Card className="card-border ccm-table-section">
    <CardBody>
      <h3 className="ccm-table-section__h3">
        Clinical Activity and Clinical Interventions
      </h3>
      <div className="ccm-table-section__activities">
        <VoiceCalls patientDetailsLoading={false} />
        <SmsActivity patientDetailsLoading={false} />
        <ClinicalNotes patientDetailsLoading={false} />
        <CCMManualInteractionTimes patientDetailsLoading={false} />
      </div>
    </CardBody>
  </Card>
);

export default ClinicalActivity;
